import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Button } from 'reactstrap'
import '../CustomCode/Custom.css'
import { CREATE_PICKLIST_QUERY } from '../../graphql.js'
import Spinner from '../Spinner/Spinner'
import { getData } from '../CustomCode/CustomUtils'
import { useNavigate } from 'react-router-dom'

const CREATE_PICKLIST = gql(CREATE_PICKLIST_QUERY)

export default function PicklistResults({ location }) {
  console.log('PicklistResults rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    getData(location, CREATE_PICKLIST, 'createPicklist', setResults, setGraphQLErrors)
  }, [location])

  function buttonClicked() {
    navigate(-1)  // go back 1 page
  }

  if (graphQLErrors.length > 0) {
    return (<div style={{width: '50%', margin: 'auto', padding: '10px', textAlign: 'center'}}><Alert color="danger">{graphQLErrors[0].message}</Alert><Button style={{margin: 'auto'}} color="primary" onClick={buttonClicked}>Go Back</Button></div>)
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    let rows = []
    let key = 1
    for (let resultRow of results) {
      rows.push(<div key={key}>{resultRow}</div>)
      key++
    }
    return (
      <div className="custom-scroll" style={{ textAlign: 'center' }}>
        <div style={{display: 'inline-block', textAlign: 'left'}}>
          <div><b>To remove the picklist, execute the following script:</b></div>
          {rows}
        </div>
      </div>
    )
  }
}